import React, { useState, useEffect } from "react";
import axios from "axios";
import colors from "../Constants/colors";

function OldPaper() {
  const [oldPapers, setOldPapers] = useState([]);
  const [form, setForm] = useState({
    title: "",
    subjectName: "",
    className: "",
    sectionName: "",
    file: null,
    description: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [teacher, setTeacher] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] placeholder:!text-[14px] focus:ring-2 focus:ring-blue-500";

useEffect(() => {
  // Get teacher info and sessionId from localStorage outside the async function
  const teacherRaw = localStorage.getItem("teacher");
  const sessionId = localStorage.getItem("currentSessionId");

  if (!teacherRaw || !sessionId) {
    console.error("Missing teacher or sessionId");
    return;
  }

  const teacherData = JSON.parse(teacherRaw);
  const teacherId = teacherData.id;

  if (!teacherId) {
    console.error("Teacher ID not found");
    return;
  }

  const fetchTeacher = async () => {
    try {
      // Fetch teacher data
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
        { params: { sessionId } } // only sessionId as query param
      );

      setTeacher(response.data);

      // Fetch classes using teacher's full name
      const { firstName, lastName } = response.data;
      fetchClasses(`${firstName} ${lastName}`);
    } catch (err) {
      console.error("Error fetching teacher data:", err);
    }
  };

  fetchTeacher();
}, []);



  useEffect(() => {
    fetchOldPapers();
  }, []);
const sessionId = localStorage.getItem("currentSessionId");
  const fetchClasses = async (teacherName) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherClasses/${teacherName}`,
        { params: { sessionId } }
      );
      setClasses(response.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    if (form.className) {
      fetchSubjects(form.className);
    }
  }, [form.className]);

  const fetchOldPapers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/papers/getPapers`,
        { params: { sessionId } }
      );
      setOldPapers(response.data);
    } catch (error) {
      console.error("Error fetching old papers:", error);
    }
  };

  const fetchSubjects = async (className) => {
    if (!teacher) return;
    try {
      const { firstName, lastName } = teacher;
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getSubjectsByTeacherAndClass/${firstName}%20${lastName}/${className}`,
        { params: { sessionId } }
      );
      if (Array.isArray(response.data.subjects)) {
        setSubjects(response.data.subjects);
      } else {
        setSubjects([]);
        console.error("Expected an array but got:", response.data);
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "className") {
      const [selectedClassName, selectedSectionName] = value.split("|");
      setForm({
        ...form,
        className: selectedClassName,
        sectionName: selectedSectionName || "",
      });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleFileChange = (e) => {
    setForm({ ...form, file: e.target.files[0] });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  try {
    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("subjectName", form.subjectName);
    formData.append("className", form.className);
    formData.append("sectionName", form.sectionName);
    formData.append("description", form.description);

    // Optional file
    if (form.file) {
      formData.append("paper", form.file);
    }

    // Optional sessionId (if your backend expects it)
    const sessionId = localStorage.getItem("currentSessionId");
    if (sessionId) formData.append("sessionId", sessionId);

    if (editingId) {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/papers/updatePaper/${editingId}`,
        formData
      );
      alert("Old paper updated successfully");
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/papers/createPaper`,
        formData
      );
      alert("Old paper created successfully");
    }

    // Reset form
    setForm({
      title: "",
      subjectName: "",
      className: "",
      sectionName: "",
      file: null,
      description: "",
    });
    setEditingId(null);

    // Refresh list
    fetchOldPapers();
  } catch (error) {
    console.error("Error saving old paper:", error.response?.data || error.message);
  } finally {
    setIsLoading(false);
  }
};


  const handleEdit = (paper) => {
    setForm({
      title: paper.title,
      subjectName: paper.subjectName,
      className: paper.className,
      sectionName: paper.sectionName,
      file: null, // don't prefill file
      description: paper.description || "",
    });
    setEditingId(paper._id);
  };

const handleDelete = async (id) => {
  const sessionId = localStorage.getItem("currentSessionId"); // make sure it's defined
  if (!window.confirm("Are you sure you want to delete this old paper?")) return;

  try {
    await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/papers/deletePaper/${id}`, // corrected endpoint
      { params: { sessionId } } // send sessionId as query param
    );
    fetchOldPapers(); // refresh the list
  } catch (error) {
    console.error("Error deleting old paper:", error.response?.data || error.message);
  }
};


  const clearForm = () => {
    setForm({
      title: "",
      subjectName: "",
      className: "",
      sectionName: "",
      file: null,
      description: "",
    });
    setEditingId(null);
  };

  const getFilteredOldPapers = () => {
    if (!form.className && !form.subjectName) return [];
    return oldPapers.filter((paper) => {
      return (
        (form.className === "" || paper.className === form.className) &&
        (form.sectionName === "" || paper.sectionName === form.sectionName) &&
        (form.subjectName === "" || paper.subjectName === form.subjectName)
      );
    });
  };

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <i className="fas fa-file-alt text-purple-600 !text-[20px]" />
          <h1 className="font-bold !text-[18px]">Old Papers</h1>
        </div>
      </div>
      <p className="text-gray-600 mb-6 !text-[14px]">
        Upload and manage previous year question papers easily.
      </p>

      {/* Add / Edit Paper Form Card */}
      <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200 mb-8">
        <div className="flex items-center gap-2 mb-4">
          <i className="fas fa-upload text-blue-600 !text-[18px]" />
          <h2 className="font-semibold !text-[18px] text-gray-800">
            {editingId ? "Update Old Paper" : "Add New Old Paper"}
          </h2>
        </div>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {/* Class */}
          <div className="flex flex-col">
            <label className={labelStyle}>Class:</label>
            <select
              name="className"
              value={
                form.className && form.sectionName
                  ? `${form.className}|${form.sectionName}`
                  : ""
              }
              onChange={handleInputChange}
              required
              className={inputStyle}
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option
                  key={cls._id}
                  value={`${cls.className}|${cls.sectionName}`}
                >
                  {cls.className} ({cls.sectionName})
                </option>
              ))}
            </select>
          </div>

          {/* Subject */}
          <div className="flex flex-col">
            <label className={labelStyle}>Subject:</label>
            <select
              name="subjectName"
              value={form.subjectName}
              onChange={handleInputChange}
              required
              disabled={!form.className}
              className={inputStyle}
            >
              <option value="">Select Subject</option>
              {subjects.map((subject, index) => (
                <option key={index} value={subject}>
                  {subject}
                </option>
              ))}
            </select>
          </div>

          {/* Title */}
          <div className="flex flex-col">
            <label className={labelStyle}>Title:</label>
            <input
              type="text"
              name="title"
              value={form.title}
              onChange={handleInputChange}
              required
              className={inputStyle}
            />
          </div>

          {/* File */}
          <div className="flex flex-col">
            <label className={labelStyle}>Upload File:</label>
            <input
              type="file"
              name="file"
              onChange={handleFileChange}
              required={!editingId}
              className="border rounded-lg px-3 py-2 outline-none !text-[14px]"
            />
          </div>

          {/* Description */}
          <div className="md:col-span-2 flex flex-col">
            <label className={labelStyle}>Description (Optional):</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleInputChange}
              className={`${inputStyle} min-h-[80px]`}
            />
          </div>

          {/* Buttons */}
          <div className="md:col-span-2 flex justify-end gap-4">
            {editingId && (
              <button
                type="button"
                onClick={clearForm}
                className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg !text-[14px]"
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              disabled={isLoading}
              className="text-white px-4 py-2 rounded-lg !text-[14px] hover:opacity-90"
              style={{ background: colors.gradientPrimary }}
            >
              {isLoading
                ? "Saving..."
                : editingId
                ? "Update Paper"
                : "Add Paper"}
            </button>
          </div>
        </form>
      </div>

      {/* Uploaded Papers Table Card */}
      <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
        <div className="flex items-center gap-2 mb-4">
          <i className="fas fa-folder-open text-green-600 !text-[18px]" />
          <h2 className="font-semibold !text-[18px] text-gray-800">
            Uploaded Papers
          </h2>
        </div>

        {getFilteredOldPapers().length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 bg-white text-center !text-[14px] rounded-md">
              <thead className="bg-gray-100 text-gray-800">
                <tr>
                  <th className="border px-4 py-2 font-semibold">#</th>
                  <th className="border px-4 py-2 font-semibold">Class</th>
                  <th className="border px-4 py-2 font-semibold">Subject</th>
                  <th className="border px-4 py-2 font-semibold">Title</th>
                  <th className="border px-4 py-2 font-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                {getFilteredOldPapers().map((paper, index) => (
                  <tr
                    key={paper._id}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="border px-4 py-2">{index + 1}</td>
                    <td className="border px-4 py-2">
                      {paper.className} ({paper.sectionName})
                    </td>
                    <td className="border px-4 py-2">
                      {paper.subjectName}
                    </td>
                    <td className="border px-4 py-2">{paper.title}</td>
                    <td className="border px-4 py-2">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => handleEdit(paper)}
                          className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded-lg !text-[13px]"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(paper._id)}
                          className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-lg !text-[13px]"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-600 !text-[14px]">
            No papers found.
          </p>
        )}
      </div>
    </div>
  );
}

export default OldPaper;
